import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';
import { seatActions } from '../actions';

@Injectable()
export class SeatsEffects {
  constructor(private actions$: Actions, private generalservice: APIService) {}

  ReserveSeat$ = createEffect(() =>
    this.actions$.pipe(
      ofType(seatActions.ReserveSeat),
      switchMap((action) => {
        return this.generalservice.reserveSeat(action.reserveSeatRequestService).pipe(
          map((response) => {
            return seatActions.ReserveSeatSuccess({
              reserveSeatResult: response
            });
          }),
          catchError((response) => {
            return of(seatActions.ReserveSeatFailed({ error: response.error }));
          })
        );
      })
    )
  );

  cancelSeat$ = createEffect(() =>
    this.actions$.pipe(
      ofType(seatActions.CancelSeat),
      switchMap((action) => {
        return this.generalservice.cancelSeat(action.gds, action.cancelSeatRequestService).pipe(
          map((response) => {
            return seatActions.CancelSeatSuccess({
              cancelSeatResult: response
            });
          })
        );
      }),
      catchError((response) => {
        return of(seatActions.CancelSeatFailed({ error: response.error }));
      })
    )
  );
}
